{
  "home": {
    "tagline": "Meer dan 1 miljoen hondeneigenaren trainen met Hundeo",
    "subline": "Aanbevolen door echte hondentrainers",
    "appStorePrefix": "Download in de",
    "playStorePrefix": "Verkrijgbaar in",
    "qrHint": "Open de app op je telefoon",
    "qrCaption": "Scan de code met je camera",
    "socialProof": "5.000+ vijfsterrenrecensies",
    "imprint": "Colofon",
    "privacy": "Privacy",
    "language": "Taal",
    "openWebsite": "Naar de website",
    "openInApp": "Openen in de Hundeo-app",
    "openInAppHint": "Je wordt naar je app gebracht",
    "openInAppButton": "Openen",
    "promoRedirectTitle": "Je aanbod wordt geopend …",
    "promoRedirectButton": "Naar je aanbod"
  }
}
